import { Fragment, useEffect } from 'react'
import HoverFullText from './HoverToolkit'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { clearErrors, deleteProductAction } from '../../redux/actions/productActions'
import Loader from '../loader/loader'
import { DELETE_PRODUCT_RESET } from '../../redux/constants/productConstants'

const SingleProduct = ({ product, index }) => {

    const dispatch = useDispatch()

    const { loading, error, message } = useSelector(state => state.productMessage)



    const handleDelete = (id) => {

        if (!id) {
            toast.error("Technical Error")
            return
        }


        dispatch(deleteProductAction(id))

    }



    useEffect(() => {
        if (error) {
            dispatch(clearErrors())
        }
        if (message) {
            dispatch({ type: DELETE_PRODUCT_RESET})
        }
    }, [message, error, dispatch])


    return (
        <Fragment>
            {loading && <Loader />}
            <div className={`flex  w-[120%] 2xl:w-full ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}>
                <div className="flex-[0.8] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                    {index + 1}
                </div>
                <div className="flex-[1.6] flex   p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    <HoverFullText text={product.scan_code} sliceLength={16} />
                </div>
                <div className="flex-[2] flex items-center  p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700 ">
                    &nbsp;&nbsp;
                    <HoverFullText text={product.description} sliceLength={14} />
                </div>
                <div className="flex-[1] flex items-center  p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700 justify-center">
                    &nbsp;&nbsp;
                    <HoverFullText text={product.unit_case} sliceLength={6} />
                </div>
                <div className="flex-[2] flex items-center  p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    &nbsp;&nbsp;
                    <HoverFullText text={product.department} sliceLength={14} />
                </div>
                <div className="flex-[1] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">

                    <HoverFullText text={product.purchase_qty} sliceLength={8} />
                </div>
                <div className="flex-[1] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    <HoverFullText text={product.sold_qty} sliceLength={8} />
                </div>
                <div className="flex-[1] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    <HoverFullText text={product.adjust_qty} sliceLength={8} />
                </div>
                <div className="flex-[1] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    <HoverFullText text={product.current_qty} sliceLength={8} />
                </div>
                <div className="flex-[1] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    $<HoverFullText text={product.each_cost} sliceLength={8} />
                </div>
                <div className="flex-[1] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    $<HoverFullText text={product.each_retail} sliceLength={8} />
                </div>
                <div className="flex-[1.5] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    $<HoverFullText text={(Number(product.each_cost) * Number(product.current_qty)).toFixed(2)} sliceLength={9} />
                </div>
                <div className="flex-[1.5] flex items-center justify-end p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[400] 2xl:text-[0.7vmax] text-slate-700">
                    $<HoverFullText text={(Number(product.each_retail) * Number(product.current_qty)).toFixed(2)} sliceLength={9} />
                </div>
                <div className="flex-[1.2] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1.1vmax] font-[400] text-slate-700 gap-[1vmax]">
                    <Link to={`/update-product?id=${product.id}`} >
                        <i className="fa-solid fa-pen-to-square "></i>
                    </Link>
                    <button
                        onClick={() => handleDelete(product.id)}
                    >
                        <i className="fa-regular fa-trash-can text-red-500"></i>
                    </button>
                </div>
            </div>
        </Fragment>
    )
}

export default SingleProduct